import React, { Fragment, ReactNode, useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronRight } from "@geist-ui/icons";
import cx from "classnames";

import styles from "./styles.module.scss";

const Frame = ({ children }: { children: ReactNode }) => {
  return <div className={styles.bg}>{children}</div>;
};

export const Collapsable = ({
  children,
  initialCollapsedValue = true,
  title,
  isFullWidth = false,
  isChildrenInSection = false,
  isBackgroundColor = false,
}: {
  children: ReactNode;
  initialCollapsedValue: boolean;
  title: string | ReactNode;
  isFullWidth?: boolean;
  isChildrenInSection?: boolean;
  isBackgroundColor?: boolean;
}) => {
  const [isCollapsed, setCollapsed] = useState(initialCollapsedValue);
  const sectionRef = useRef<HTMLDivElement>(null);

  const Wrapper = isChildrenInSection ? Frame : Fragment;
  useEffect(() => {
    if (!isCollapsed && sectionRef.current) {
      const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
      };
      scrollToSection();
    }
  }, [isCollapsed]);

  return (
    <Wrapper>
      <div
        ref={sectionRef}
        className={cx(styles.title, styles.clickable, {
          [styles.fullWidth]: isFullWidth,
          [styles.backgroundColor]: isBackgroundColor,
        })}
        onClick={() => {
          setCollapsed((prev) => !prev);
        }}
      >
        {isCollapsed ? <ChevronRight /> : <ChevronDown />}
        {title}
      </div>
      {!isCollapsed && (
        <div
          className={cx(styles.children, {
            [styles.backgroundColor]: isBackgroundColor,
          })}
        >
          {children}
        </div>
      )}
    </Wrapper>
  );
};
